import React, { useState } from 'react'
import {
    Button, Col, Form, FormGroup, FormText, Input, InputGroup, InputGroupText, Label, Row, Spinner,
} from 'reactstrap'
import CredentialsFields from './CredentialsFields'
import { DEFAULT_LOOKBACK_DAYS, GATEWAY_TIMEOUT_NOTE } from './constants'

function AnalyseForm({ onRead, reading, userId, password, setUserId, setPassword }) {
    const [lookbackDays, setLookbackDays] = useState(String(DEFAULT_LOOKBACK_DAYS))
    const [phoneNumber, setPhoneNumber] = useState('')
    const [ccEmail, setCcEmail] = useState('')
    const [touched, setTouched] = useState(false)

    const days = parseInt(lookbackDays, 10)
    const errors = {
        userId: userId.trim() ? null : 'Required',
        password: password ? null : 'Required',
        lookbackDays: Number.isInteger(days) && days >= 1
            ? null
            : 'A whole number of days, at least 1',
    }
    const invalid = Object.values(errors).some(Boolean)

    const submit = event => {
        event.preventDefault()
        setTouched(true)
        if (invalid) return
        onRead({
            userId: userId.trim(),
            password,
            lookbackDays: days,
            // The lambda fills every phone and email box the facilities ask for with these two.
            // Left empty, those boxes are written empty.
            phoneNumber: phoneNumber.trim(),
            ccEmail: ccEmail.trim(),
        })
    }

    return (
        <div>
            <p className="text-muted small mb-4">
                Reads this account's OpenDock appointments for the period below.
                Settings the appointments determine are written immediately, without
                confirmation. Settings they do not determine are listed for you to answer.
            </p>

            <Form onSubmit={submit} noValidate style={{ maxWidth: 480 }}>
                <fieldset className="mb-4" disabled={reading}>
                    <legend className="odo-legend">OpenDock account</legend>
                    <CredentialsFields
                        idPrefix="odo-run"
                        userId={userId}
                        password={password}
                        setUserId={setUserId}
                        setPassword={setPassword}
                        errors={errors}
                        touched={touched}
                    />
                </fieldset>

                <fieldset className="mb-4" disabled={reading}>
                    <legend className="odo-legend">How far back</legend>
                    <div style={{ width: 140 }}>
                        <InputGroup>
                            <Input
                                id="odo-run-lookback"
                                type="number"
                                min={1}
                                aria-label="Look back, in days"
                                value={lookbackDays}
                                invalid={touched && !!errors.lookbackDays}
                                onChange={e => setLookbackDays(e.target.value)}
                            />
                            <InputGroupText>days</InputGroupText>
                        </InputGroup>
                    </div>
                    {touched && errors.lookbackDays && (
                        <FormText className="text-danger">{errors.lookbackDays}</FormText>
                    )}
                </fieldset>

                <fieldset className="mb-4" disabled={reading}>
                    <legend className="odo-legend">Contact for the booking</legend>
                    <Row className="g-2">
                        <Col sm={6}>
                            <FormGroup className="mb-0">
                                <Label for="odo-run-phone" className="mb-1 small">Phone</Label>
                                <Input
                                    id="odo-run-phone"
                                    type="tel"
                                    value={phoneNumber}
                                    onChange={e => setPhoneNumber(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup className="mb-0">
                                <Label for="odo-run-email" className="mb-1 small">Email</Label>
                                <Input
                                    id="odo-run-email"
                                    type="email"
                                    autoComplete="off"
                                    value={ccEmail}
                                    onChange={e => setCcEmail(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </fieldset>

                <div>
                    <Button color="primary" type="submit" disabled={reading}>
                        {reading && <Spinner size="sm" className="me-2" />}
                        {reading ? 'Reading bookings…' : 'Read bookings'}
                    </Button>
                    {reading && (
                        <div className="text-muted small mt-2">{GATEWAY_TIMEOUT_NOTE}</div>
                    )}
                </div>
            </Form>
        </div>
    )
}

export default AnalyseForm
